<!-- TEMPLATE FOR MODAL DIALOG -->

<div class="modal-header">
  <div class="modal-title">
      <h3>Preliminära leveransveckor</h3>
  </div>
  <button type="button" class="close" (click)="close()" aria-label="Close">
      <i title="Stäng" class="fa-regular fa-xmark mr-2"></i>
  </button>
</div>

<div class="modal-body text-md bg-white">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="alert alert-info" role="alert">
                  Leveransveckorna nedan är endast preliminära och kan komma att ändras vid bekräftande av en offert beroende på fasta leveransdagar, förändrad kapacitet samt helgdagar.
                  <br />
                  <br />
                  Leveransveckorna anges som <b>årvecka/dag</b>
                  <br /><i>Exempel: {{currentYear}}01/1 = Leveransstart år 20{{currentYear}}, vecka 01 / dag 1 (måndag).</i>
                  <br />
                  <br />
                  Leveranstiderna gäller för samtliga träkulörer och de 10 standard alukulörerna.
              </div>
          </div>
      </div>

      <div class="row mt-3">
          <div class="col-lg-12">
              <!--PRODUCT HEADING-->
              <div class="row">
                  <div class="col-5"><span class="text-bold-lg">Produkt</span></div>
                  <div class="col-3"><span class="text-bold-lg">Vecka ÅF</span></div>
                  <div class="col-4"><span class="text-bold-lg">Vecka Objekt</span></div>
              </div>

              @for(item of estimatedDlvWeeks; track item.RECID) {
                  <div class="row">
                      <div class="col-12">

                          <!--HEADINGS-->
                          <div class="row hover">
                              @if(isNewHeading(item.HEADING)) {
                                  <div class="col-12">
                                      <hr />
                                      <h4 class=" mb-2 mt-2">{{item.HEADING}}</h4>
                                  </div>
                              }

                              <!--PRODUCT ROW-->
                              <div class="col-5 text-bold-sm on-hover left">{{item.PRODUCT}}</div>
                              <div class="col-3 on-hover">{{formatWeek(item.WEEK, item.WEEKDAY)}}</div>
                              <div class="col-4 on-hover right">{{formatWeek(item.WEEKOBJECT, item.WEEKDAYOBJECT)}}</div>
                          </div>
                      </div>
                  </div>
              }
          </div>
      </div>

      <div class="row">
          <div class="col-12 mt-4">
              <button class="btn btn-sm btn-primary" (click)="downloadPDF()"><i class="fa-regular fa-file-pdf fa-lg mr-2"></i> Öppna som PDF</button>
          </div>
      </div>
      @if(errorMessage) {
          <div class="row">
              <div class="col-12">
                  <div class="alert alert-danger">
                      {{errorMessage}}
                  </div>
              </div>
          </div>
      }
  </div>
</div>

<div class="modal-footer bg-light">
  <button class="btn btn-sm btn-primary" (click)="close()">Stäng</button>
</div>

